import { createSlice } from '@reduxjs/toolkit';
import { createUser } from '../usersActions';

export const createUserSlice = createSlice({
    name: 'createUser',
    initialState: {
        data: {},
        error: '',
        loading: false
    },
    reducers: {
        clearState: () => ({ data: {} })
    },
    extraReducers: {
        [createUser.pending]: (state) => ({
            ...state,
            error: '',
            loading: true
        }),

        [createUser.fulfilled]: (state, { payload }) => ({
            ...state,
            loading: false,
            data: payload.data
        }),

        [createUser.rejected]: (state, { payload }) => ({
            ...state,

            error: 'There is an error occured, please try again later !',
            loading: false
        })
    }
});

export const { clearState } = createUserSlice.actions;
export default createUserSlice.reducer;
